import { useState } from "react";
import { PlayCircle } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";

export default function PromoVideo() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button onClick={() => setOpen(true)} className="inline-flex items-center gap-2.5 px-2 py-3.5 text-sm font-semibold text-white/90 hover:text-[#D4AF37] transition-colors" data-testid="hero-watch-video-btn">
        <PlayCircle className="w-6 h-6 text-[#D4AF37]" />Watch our Black Belt promo
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl p-0 bg-black border-0 overflow-hidden" data-testid="promo-video-dialog">
          <DialogTitle className="sr-only">Dexterity Consult Black Belt promo</DialogTitle>
          {open && <video src="/brand/promo.mp4" controls autoPlay playsInline className="w-full aspect-video bg-black" data-testid="promo-video" />}
        </DialogContent>
      </Dialog>
    </>
  );
}
